/// <amd-module name="CodeCoverage/Common/Constants" />
export class PerfScenarios {
    public static Area = "CodeCoverage";

    // Scenarios
    public static CodeCoverageTab = "CodeCoverage.Tab";
    public static TimelineSummary = "CodeCoverage.TimelineSummary";
    public static APICall = "CodeCoverage.ApiCall";
}

export class TelemetryEvents {
    public static Area = "CodeCoverage";

    // Events
    public static DownloadLinkClicked = "DownloadLinkClicked";
    public static DetailsListSortClicked = "DetailsListSortClicked";
    public static CodeCoverageTabClicked = "CodeCoverageTabClicked";
    public static CodeCoverageTabInProgress = "CodeCoverageTabInProgress";
    public static CodeCoverageFailureMessage = "CodeCoverageFailureMessage";
    public static CodeCoverageSummaryCalled = "CodeCoverageSummaryCalled";
    public static FolderViewCodeCoverageViewed = "FolderViewCodeCoverageViewed";
    public static NoCodeCoverageConfiguredClicked = "NoCodeCoverageConfiguredClicked";
}
